import { PersonaCard } from '@/entities/persona';
import { AnalysisMarkdown } from '@/pages/AnalysisResult/components';
import { ageTags } from '../lib';
import type { AudienceDraftCard } from '../lib/audienceDrafts';
import { SuggestedAudienceBadge } from './SuggestedAudienceBadge';
import { SuggestedAudiencePortrait } from './SuggestedAudiencePortrait';

interface SuggestedAudienceCardsProps {
  cards: AudienceDraftCard[];
  onOpen?: (draftId: string) => void;
}

/**
 * The audiences IQ suggested, beside the ones the report was given.
 *
 * A card appears the moment the report does, named as the research named it, and keeps that
 * name once its persona is built: the rest of the card fills in, but an audience the user has
 * already read about is never renamed.
 */
export const SuggestedAudienceCards = ({ cards, onOpen }: SuggestedAudienceCardsProps) => {
  return (
    <>
      {cards.map(({ draftId, status, saved, segment, persona }) => (
        <PersonaCard
          key={draftId}
          name={persona?.segmentName ?? segment.name}
          age={persona?.demographicsData?.data?.age ?? segment.age}
          title={persona?.demographicsData?.data?.profession ?? segment.title}
          tags={ageTags(persona?.demographicsData?.data?.age ?? segment.age)}
          description={<AnalysisMarkdown text={persona?.personaBrief ?? segment.description} />}
          photoAssetId={persona?.photoAssetId}
          imageFallback={
            <SuggestedAudiencePortrait building={status === 'pending' || status === 'processing'} />
          }
          badge={<SuggestedAudienceBadge status={status} saved={saved} />}
          badgePlacement="tags"
          onClick={status === 'ready' && onOpen ? () => onOpen(draftId) : undefined}
        />
      ))}
    </>
  );
};
